import { Box, Grid, Stack } from '@mantine/core';

import { AppName } from 'models';

import { Content, EXTRA_WIDE_CONTENT_WIDTH } from 'components/page/Content';
import { Page } from 'components/page/Page';

import { DashboardAccessRequests } from './DashboardAccessRequests';
import { DashboardCompanyProfile } from './DashboardCompanyProfile';
import { DashboardDiscover } from './DashboardDiscover';
import { DashboardEvent } from './DashboardEvent';
import { DashboardHero } from './DashboardHero';
import { DashboardHeroReplus } from './DashboardHeroReplus';
import { DashboardInbox } from './DashboardInbox';
import { DashboardLinks } from './DashboardLinks';
import { DashboardProducts } from './DashboardProducts';
import { DashboardRecentDesigns } from './DashboardRecentDesigns';
import { DashboardSaved } from './DashboardSaved';
import { DashboardTeam } from './DashboardTeam';

import cx from './Dashboard.module.scss';

const Dashboard = ({ app = AppName.DCIDE }: { app?: AppName }) => {
    const replus = app === AppName.REPLUS;

    return (
        <Page>
            {replus ? <DashboardHeroReplus /> : <DashboardHero />}
            <Box className={cx.root} data-with-bg="grid" data-replus={replus || undefined}>
                <Box className={cx.content}>
                    <Content width={EXTRA_WIDE_CONTENT_WIDTH}>
                        <Stack gap="xl">
                            <Grid columns={12} gap="lg">
                                <Grid.Col span={{ base: 12, md: 7 }}>
                                    <Stack gap="lg">
                                        {!replus && <DashboardRecentDesigns app={app} />}
                                        <DashboardEvent />
                                        <DashboardCompanyProfile />
                                        <DashboardProducts />
                                        {replus && <DashboardRecentDesigns app={app} />}
                                        <Box visibleFrom="sm">
                                            <DashboardSaved />
                                        </Box>
                                    </Stack>
                                </Grid.Col>
                                <Grid.Col span={{ base: 12, md: 5 }}>
                                    <Stack gap="lg">
                                        <DashboardAccessRequests />
                                        <Stack gap="lg" visibleFrom="md">
                                            <DashboardInbox />
                                            <DashboardTeam />
                                        </Stack>
                                        <DashboardLinks />
                                    </Stack>
                                </Grid.Col>
                            </Grid>
                        </Stack>
                    </Content>
                </Box>
            </Box>
            {!replus && (
                <Box component="section" className={cx.discover}>
                    <Content width={EXTRA_WIDE_CONTENT_WIDTH}>
                        <DashboardDiscover />
                    </Content>
                </Box>
            )}
        </Page>
    );
};

export { Dashboard };
